module.exports = __webpack_public_path__ + "img/greece.de9a6eb5.png";